// wartet, bis das DOM geladen ist
document.addEventListener('DOMContentLoaded', function() {
  // alle Menüeinträge mit Dropdown ermitteln (anpassen, falls Ihr Theme andere Klassen verwendet)
  var parentMenuItems = document.querySelectorAll('div.menu__item.parent');
  parentMenuItems.forEach(function(menuItem) {
    // nur der Top-Level-Link soll beim Klick navigieren
    var topLink = menuItem.querySelector('a.navlink--toplevel, a[data-top-link]');
    if (!topLink) {
      return;
    }

    topLink.addEventListener('click', function(event) {
      event.preventDefault();
      event.stopPropagation();
      window.location.href = topLink.href;
    });
  });

  if (window.innerWidth < 750) {                                                                                            
    document.querySelectorAll('.product-cutline').forEach(el => {                                                           
      el.innerHTML = el.innerHTML.replace(' – ', '<br>')
    });                                                                                                                     
  }    
}); 